export enum EClientKey {
  GS_RETAIL = "gsretail",
  OLIVE_YOUNG = "oliveyoung",
  VNTG = "vntg",
  EST_AID = "estaid",
  GANGNAM_UNNI = "gangnamunni",
  HEUM = "heum",
  LEMON_BASE = "lemonbase",
  RIIID = "riiid",
  COINONE = "coinone",
  LEVIT = "levit",
  OHO = "ohora",
  KREAM = "kream",
  WISELY = "wisely",
  MODUSIGN = "modusign",
  YOUNIV = "youniv",
  HANBAEK = "hanbaek",
  VROONG = "vroong",
  ATHOME = "athome",
}

interface ClientLogoInfoType {
  name: string;
  logoWidth: number;
}

export const CLIENT_LOGO_INFO: Record<EClientKey, ClientLogoInfoType> = {
  gsretail: {
    name: "GS리테일",
    logoWidth: 192,
  },
  oliveyoung: {
    name: "올리브영",
    logoWidth: 270,
  },
  vntg: {
    name: "VNTG",
    logoWidth: 147,
  },
  estaid: {
    name: "이스트에이드",
    logoWidth: 169,
  },
  gangnamunni: {
    name: "강남언니",
    logoWidth: 176,
  },
  heum: {
    name: "혜움",
    logoWidth: 140,
  },
  lemonbase: {
    name: "레몬베이스",
    logoWidth: 183,
  },
  riiid: {
    name: "뤼이드",
    logoWidth: 120,
  },
  coinone: {
    name: "코인원",
    logoWidth: 220,
  },
  levit: {
    name: "레브잇",
    logoWidth: 152,
  },
  ohora: {
    name: "오호라",
    logoWidth: 132,
  },
  kream: {
    name: "크림",
    logoWidth: 172,
  },
  wisely: {
    name: "와이즐리",
    logoWidth: 117,
  },
  modusign: {
    name: "모두싸인",
    logoWidth: 191,
  },
  youniv: {
    name: "유니브",
    logoWidth: 167,
  },
  hanbaek: {
    name: "한백",
    logoWidth: 197,
  },
  vroong: {
    name: "브룽",
    logoWidth: 197,
  },
  athome: {
    name: "엣홈",
    logoWidth: 197,
  },
};

export const CLIENT_LOGOS = Object.keys(CLIENT_LOGO_INFO) as EClientKey[];

interface InterviewType {
  client: EClientKey;
  content: string;
  blogSlug: string;
}

export const INTERVIEWS: InterviewType[] = [
  {
    client: EClientKey.GANGNAM_UNNI,
    content: "서치라이트AI 역량 데이터로 증강으로 찾고 있던 시니어 포지션 채용에 성공했어요.",
    blogSlug: "healingpaper-hrbp-recruiting-product",
  },
  {
    client: EClientKey.EST_AID,
    content: "인재에 대한 갈증이 있으신 분이라면 서치라이트AI가 딱 찾던 서비스일 것 같아요.",
    blogSlug: "ceo-hiring-case",
  },
  {
    client: EClientKey.HANBAEK,
    content: "우리가 원하는 사람이 누구인지, 서치라이트AI와 함께 처음으로 명확히 알게 됐어요.",
    blogSlug: "direct-sourcing-case",
  },
];
